import { render, staticRenderFns } from "./BindersCreate.vue?vue&type=template&id=5071a348"
import script from "./BindersCreate.vue?vue&type=script&lang=js"
export * from "./BindersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports